export default __webpack_public_path__ + "static/media/Daniel-Brooks.35d2e957.jpg";